import { DocumentStatus } from './DocumentStatus.js';
import {
  mapDtoList,
  optionalEnum,
  optionalString,
  requireNumber,
  requireObject,
  requireString,
} from './parse.js';

/**
 * Mirrors com.medprompt.document.DocumentPreview
 *
 * @typedef {object} DocumentPreviewData
 * @property {string} documentId
 * @property {string|null} title
 * @property {number} timestamp
 * @property {string|null} status
 */

/**
 * @param {object} raw
 * @returns {DocumentPreviewData}
 */
export function fromDocumentPreviewData(raw) {
  const source = requireObject(raw, 'DocumentPreview');
  return {
    documentId: requireString(source, 'documentId', 'DocumentPreview'),
    title: optionalString(source.title),
    timestamp: requireNumber(source, 'timestamp', 'DocumentPreview'),
    status: optionalEnum(source.status, DocumentStatus, 'DocumentPreview', 'status'),
  };
}

/**
 * @param {unknown} raw
 * @returns {DocumentPreviewData[]}
 */
export function fromDocumentPreviewDataList(raw) {
  return mapDtoList(raw, 'DocumentPreview', fromDocumentPreviewData);
}
